/* Inquiry identity, attribution and consent snapshot. Shopify permission readiness and stable submission snapshot. v3.1 */
(function () {
  'use strict';
  if (window.__nhlInquiryAttribution) return;
  window.__nhlInquiryAttribution = true;
  var KEY = 'nhl:inquiry:attribution:v1', TTL = 30 * 86400000;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'placement'];
  var LABELS = ['Source', 'Medium', 'Campaign', 'Ad set', 'Ad', 'Placement'];
  var GOOGLE_CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid'];
  var GOOGLE_CLICK_LABELS = ['GCLID', 'GBRAID', 'WBRAID'];
  var memory = null, privacyLoadAttempts = 0, privacyLoading = false;
  var privacyTimer = null, privacyChecks = 0;
  function privacyReady() {
    var p = permissionSnapshot();
    return p.analytics !== 'unknown' && p.marketing !== 'unknown' && p.sale !== 'unknown';
  }
  function ensurePrivacy() {
    if (privacyReady()) { refresh(); return; }
    var shop = window.Shopify;
    if (shop && typeof shop.loadFeatures === 'function' && !privacyLoading && privacyLoadAttempts < 2) {
      privacyLoading = true; privacyLoadAttempts++;
      try {
        shop.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function(error) {
          privacyLoading = false;
          if (!error) refresh();
        });
      } catch (_) { privacyLoading = false; }
    }
    // Shopify may finish its loader after DOMContentLoaded, or return a partial API.
    // A bounded retry never converts missing/denied permission into permission.
    if (!privacyTimer && privacyChecks++ < 40) {
      privacyTimer = setTimeout(function() { privacyTimer = null; ensurePrivacy(); }, 250);
    }
  }
  function permitted() {
    try {
      var p = window.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() && p.marketingAllowed();
    } catch (_) { return false; }
  }
  function clean(value) {
    // Campaign metadata only; reject unresolved macros, control chars and email-like values.
    return typeof value === 'string' && /^[a-zA-Z0-9_. -]{1,120}$/.test(value) ? value : '';
  }
  function cleanGoogleClick(value) {
    // Google click identifiers are URL-safe opaque values, never invented or derived.
    return typeof value === 'string' && /^[a-zA-Z0-9._~-]{1,500}$/.test(value) ? value : '';
  }
  function cleanPath(value) {
    return typeof value === 'string' && value.length <= 500 && value.charAt(0) === '/' && !/[\u0000-\u001f\u007f]/.test(value) ? value : '';
  }
  function touchValid(t) {
    return t && Number.isFinite(t.at) && Date.now() >= t.at && Date.now() - t.at < TTL &&
      Array.isArray(t.values) && t.values.length === 6 && t.values.every(function(v) { return v === '' || clean(v) === v; }) &&
      (typeof t.googleClicks === 'undefined' || (Array.isArray(t.googleClicks) && t.googleClicks.length === 3 &&
        t.googleClicks.every(function(v) { return v === '' || cleanGoogleClick(v) === v; }))) &&
      (typeof t.landingPath === 'undefined' || cleanPath(t.landingPath) === t.landingPath);
  }
  function read() {
    try {
      var r = JSON.parse(localStorage.getItem(KEY));
      if (r && touchValid(r.first) && touchValid(r.last)) return r;
      localStorage.removeItem(KEY);
    } catch (_) { /* Storage denied: retain current-page attribution in memory only. */ }
    return memory && touchValid(memory.first) && touchValid(memory.last) ? memory : null;
  }
  function capture() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return null;
    if (!permitted()) {
      memory = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
      return null;
    }
    var r = read(), q = new URLSearchParams(location.search);
    var values = PARAMS.map(function(k) { return clean(q.get(k)); });
    var googleClicks = GOOGLE_CLICK_PARAMS.map(function(k) { return cleanGoogleClick(q.get(k)); });
    if ((values[0] && values[1]) || googleClicks.some(function(v) { return !!v; })) {
      var t = {at: Date.now(), values: values, googleClicks: googleClicks, landingPath: cleanPath(location.pathname)};
      // Do not reset the timestamp on every form submission on the same page.
      if (!r || JSON.stringify([r.last.values, r.last.googleClicks || [], r.last.landingPath || '']) !== JSON.stringify([values, googleClicks, t.landingPath])) {
        r = {first: r ? r.first : t, last: t};
      }
    }
    memory = r;
    try { if (r) localStorage.setItem(KEY, JSON.stringify(r)); } catch (_) {}
    return r;
  }
  function field(form, label, value) {
    var name = 'contact[' + label + ']';
    var el = form.querySelector('input[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input'); el.type = 'hidden'; el.name = name;
      el.setAttribute('data-nhl-attribution', 'true'); form.appendChild(el);
    }
    el.value = value;
    el.setAttribute('value', value);
  }
  function permissionSnapshot() {
    var result = {analytics: 'unknown', marketing: 'unknown', sale: 'unknown'};
    var p = window.Shopify && window.Shopify.customerPrivacy;
    [['analytics','analyticsProcessingAllowed'],['marketing','marketingAllowed'],['sale','saleOfDataAllowed']].forEach(function(pair) {
      try {
        if (p && typeof p[pair[1]] === 'function') {
          var value = p[pair[1]]();
          if (typeof value === 'boolean') result[pair[0]] = value ? 'allowed' : 'denied';
        }
      } catch (_) { /* One unavailable purpose must not hide the other decisions. */ }
    });
    return result;
  }
  function metaCookie(name) {
    try {
      var value = document.cookie.split(';').map(function(s) { return s.trim(); }).find(function(s) { return s.indexOf(name + '=') === 0; });
      value = value ? value.slice(name.length + 1) : '';
      return /^fb\.\d\.\d{13}\.[a-zA-Z0-9_-]{1,500}$/.test(value) ? value : '';
    } catch (_) { return ''; }
  }
  function measurement(form, submitting) {
    // The gallery shortlist carries the same tracking fields; the importer logs it separately and never sends it to Meta as a Lead.
    if (['commission-form','contact-band-form','private-gallery-shortlist'].indexOf(form.id) === -1) return;
    var p = permissionSnapshot(), shop = window.Shopify;
    var live = shop && shop.theme && shop.theme.role === 'main' && !shop.designMode && !/[?&](preview_theme_id|preview_key|preview_script_id)=/.test(location.search);
    field(form, 'Tracking version', live ? '3' : 'preview');
    field(form, 'Tracking event ID', form.__nhlInquiryId);
    field(form, 'Tracking analytics', p.analytics);
    field(form, 'Tracking marketing', p.marketing);
    field(form, 'Tracking data sharing', p.sale);
    field(form, 'Tracking permission source', privacyReady() ? 'shopify-privacy-api' : 'shopify-privacy-api-unavailable');
    // Non-identifying readiness only; useful when investigating missing fields.
    form.setAttribute('data-nhl-tracking-ready', privacyReady() ? 'true' : 'false');
    if (!submitting) return;
    var selected = form.querySelector('input[data-label="Build type"]:checked');
    var type = form.id === 'commission-form' ? (selected && selected.value === 'Mod my existing watch' ? 'watch_modification' : 'custom_watch') : form.id === 'private-gallery-shortlist' ? 'gallery_shortlist' : 'general';
    field(form, 'Tracking inquiry type', type);
    if (!form.__nhlSubmittedAt) form.__nhlSubmittedAt = new Date().toISOString();
    field(form, 'Tracking submitted UTC', form.__nhlSubmittedAt);
    field(form, 'Tracking source URL', location.origin + location.pathname);
    // Read genuine existing Meta cookies only when all relevant purposes are allowed.
    // No fabricated click IDs and no browser IP collection.
    if (live && p.analytics === 'allowed' && p.marketing === 'allowed' && p.sale === 'allowed') {
      field(form, 'Tracking browser ID', metaCookie('_fbp'));
      field(form, 'Tracking click ID', metaCookie('_fbc'));
      field(form, 'Tracking user agent', navigator.userAgent.slice(0,500));
    }
  }
  function populate(form, r, submitting) {
    if (!form.querySelector('input[name="contact[email]"]')) return;
    if (!form.__nhlInquiryId) {
      if (!window.crypto || typeof window.crypto.randomUUID !== 'function') return;
      form.__nhlInquiryId = 'NHL-' + window.crypto.randomUUID();
    }
    field(form, 'Inquiry ID', form.__nhlInquiryId);
    form.querySelectorAll('input[data-nhl-attribution="true"]').forEach(function(el) {
      if (el.name !== 'contact[Inquiry ID]') el.remove();
    });
    // Consent/loader callbacks may run while gallery encryption or CAPTCHA is
    // preparing navigation. Keep the existing submission timestamp/context then.
    measurement(form, !!submitting || !!form.__nhlSubmittedAt);
    if (!r) return;
    ['first', 'last'].forEach(function(which) {
      var prefix = which === 'first' ? 'First ad visit - ' : 'Latest ad visit - ';
      var touch = r[which];
      touch.values.forEach(function(value, i) { if (value) field(form, prefix + LABELS[i], value); });
      (touch.googleClicks || []).forEach(function(value, i) { if (value) field(form, prefix + GOOGLE_CLICK_LABELS[i], value); });
      if (touch.landingPath) field(form, prefix + 'Landing path', touch.landingPath);
      field(form, prefix + 'Date UTC', new Date(touch.at).toISOString());
    });
  }
  function refresh() {
    var r = capture();
    document.querySelectorAll('form').forEach(function(form) { populate(form, r); });
  }
  // Capture phase ensures fields exist before native form serialization.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    try {
      if (!form || ['commission-form','contact-band-form','private-gallery-shortlist'].indexOf(form.id) === -1) {
        populate(form, capture(), true); return;
      }
      // Match all supported enquiry forms. Give a late Shopify API one short
      // opportunity to resolve before serialization; never block a real enquiry
      // indefinitely, force consent, bypass CAPTCHA, or call form.submit().
      if (!privacyReady() && form.__nhlPrivacyWaiting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (!privacyReady() && !form.__nhlPrivacyAttempted && typeof form.requestSubmit === 'function' && !e.defaultPrevented) {
        e.preventDefault(); e.stopImmediatePropagation();
        form.__nhlPrivacyAttempted = true; form.__nhlPrivacyWaiting = true;
        var submitter = e.submitter, began = Date.now();
        ensurePrivacy();
        function resume() {
          if (!privacyReady() && Date.now() - began < 1500) { setTimeout(resume, 50); return; }
          form.__nhlPrivacyWaiting = false; form.__nhlPrivacyResume = true;
          populate(form, capture(), true);
          // Resume in a task after the browser clears the submit-event re-entry flag.
          setTimeout(function() {
            try {
              if (submitter && submitter.form === form && !submitter.disabled) form.requestSubmit(submitter);
              else form.requestSubmit();
            } finally { form.__nhlPrivacyResume = false; }
          }, 0);
        }
        setTimeout(resume, 0); return;
      }
      populate(form, capture(), true);
    } catch (_) { /* Never block native form delivery. */ }
  }, true);
  document.addEventListener('visitorConsentCollected', function() { refresh(); ensurePrivacy(); });
  document.addEventListener('customerPrivacyApiLoaded', function() { refresh(); ensurePrivacy(); });
  function start() { refresh(); ensurePrivacy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
